function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'seda': 'rgb(128, 128, 128)','cierna': 'rgb(0, 0, 0)','zelena': 'rgb(1, 50, 32)','cervena': 'rgb(178, 34, 34)','hneda': 'rgb(150, 75, 0)','svetlohneda': 'rgb(196, 164, 132)','modra': 'rgb(100, 149, 237)','medena': 'rgb(184, 115, 51)','cervena-ral-3009': 'rgb(178, 34, 34)','hneda-ral-8017': 'rgb(150, 75, 0)','seda-ral-7024': 'rgb(128, 128, 128)','pustna-hneda': 'rgb(203, 165, 96)','namornicka-modra': 'rgb(0, 0, 128)','cervena-mansion-katrilli-rocky-jazzy-3t': 'rgb(178, 34, 34)','hneda-mansion-katrilli-rocky-jazzy-3t': 'rgb(150, 75, 0)','zelena-katrilli': 'rgb(1, 50, 32)','cierna-classic-kl-foxy-rocky-3t': 'rgb(0, 0, 0)','seda-classic-kl': 'rgb(128, 128, 128)','cervena-classic-kl': 'rgb(178, 34, 34)','hneda-classic-kl': 'rgb(150, 75, 0)','zelena-classic-kl': 'rgb(1, 50, 32)','seda-jazzy': 'rgb(128, 128, 128)','seda-mansion-rocky-foxy': 'rgb(128, 128, 128)','medena-hneda-rocky-jazzy': 'rgb(184, 115, 51)','pustna-hneda-rocky': 'rgb(203, 165, 96)','namornicka-modra-rocky': 'rgb(0, 0, 128)','medena-mansion': 'rgb(184, 115, 51)','mach': 'rgb(102, 117, 98)','kora-stromov': 'rgb(88, 69, 62)','jesenna-cervena': 'rgb(109, 60, 53)','honey': 'rgb(214, 160, 85)','teak': 'rgb(185, 111, 49)','graphite-grey': 'rgb(131, 118, 102)','sivo-antracitova-ral-7016': 'rgb(88, 88, 89)','cervena-hrdzava-ral-3009': 'rgb(190, 23, 23)','hnedo-cokoladova-ral-8017': 'rgb(86, 4, 0)','cerveno-tehlova-ral-8004': 'rgb(142, 25, 0)','cierna-hlboka-ral-9005': 'rgb(11, 11, 11)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor','farba','farba:',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
